export const AGENT_ONBOARDING_START_PATH = "/onboarding/start/website";

/** A teammate who joined an existing workspace says who they are here instead of setting up a project. */
export const AGENT_ONBOARDING_JOIN_PATH = "/onboarding/start/join";

/** Marks the URL the Agent app last handed to another app, so a hand-off that comes straight back shows "Page not found" instead of reloading forever. */
export const AGENT_DOCUMENT_ROUTE_HANDOFF_STORAGE_KEY =
  "replo.agent.documentRouteHandoff";

export function getNewProjectOnboardingPath(workspaceId: string) {
  return `${AGENT_ONBOARDING_START_PATH}?${new URLSearchParams({
    entry: "new-project",
    workspaceId,
  }).toString()}`;
}

/** Where a workspace changes or buys its plan in the dashboard. */
export function getWorkspaceBillingSettingsPath(workspaceId: string) {
  return `/workspace/${encodeURIComponent(workspaceId)}/settings/billing`;
}

const agentApplicationPathPrefixes = [
  "/action",
  "/agent",
  "/share/agent",
  "/share/preview",
  "/share/registry",
  "/onboarding/start",
];

const agentApplicationExactPaths = new Set([
  "/cli-auth",
  "/oauth/authorize",
  "/onboarding/agent-billing",
  "/settings/billing",
  "/templates",
]);

export function isAgentApplicationPath(pathname: string) {
  return (
    agentApplicationExactPaths.has(pathname) ||
    agentApplicationPathPrefixes.some((pathPrefix) => {
      return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
    })
  );
}
